import { z } from 'zod';

export const rolesSchema = z.object({
  name: z
    .string()
    .min(1, 'El nombre del rol es obligatorio.')
    .max(100, 'El nombre del rol no puede superar los 100 caracteres.'),

  description: z
    .string()
    .max(500, 'La descripción no puede superar los 500 caracteres.')
    .optional()
    .or(z.literal('')),

  status: z.boolean(),
});
